<template>
  <div
    id="lectures-info"
    v-if="opportunityBeingVisited.lecture.isActive"
    class="container"
  >
    <div class="columns">
      <div id="lectures-box" class="column box">
        <lectures-title
          title="Palestra (Presencial) ou Webinar (Online)"
          buttonText="Solicitar"
          :description="description"
          :isCardOpen="isCardOpen"
          @open-card="$emit('open-card', 'lecture')"
          @close-card="$emit('close-card', 'lecture')"
        />

        <div class="columns action-details" v-if="isCardOpen">
          <themes
            :themes="opportunityBeingVisited.lecture.themes"
            :specificThemes="opportunityBeingVisited.lecture.specificThemes"
          />

          <prerequisites
            :minPublic="opportunityBeingVisited.lecture.minPublic"
            :advance="opportunityBeingVisited.lecture.advance"
            :limitDateForRequests="opportunityBeingVisited.limitDateForRequests"
            :limitDateForActions="opportunityBeingVisited.limitDateForActions"
            :courses="opportunityBeingVisited.lecture.courses"
            :states="opportunityBeingVisited.lecture.states"
          />

          <counterparts
            :treatmentPronoun="opportunityBeingVisited.treatmentPronoun"
            :businessName="opportunityBeingVisited.businessName"
            :logosZipURL="opportunityBeingVisited.page.logosZipURL"
            action="a palestra"
          />
        </div>
      </div>
    </div>

    <b-modal :active.sync="isRequestModalActive">
      <lecture-request-modal
        :minPublic="opportunityBeingVisited.lecture.minPublic"
        :advance="opportunityBeingVisited.lecture.advance"
      />
    </b-modal>
  </div>
</template>

<script>
import { descriptions } from "../../../assets/js/actions-descriptions";
import lecturesTitle from "./card/Title";
import themes from "./card/Themes";
import prerequisites from "./card/Prerequisites";
import counterparts from "./card/Counterparts";
import lectureRequestModal from "../request-modal/LectureRequestModal";

export default {
  props: ["opportunityBeingVisited", "isCardOpen"],

  components: {
    lecturesTitle,
    themes,
    prerequisites,
    counterparts,
    lectureRequestModal
  },

  data() {
    return {
      description: "",
      isRequestModalActive: false
    };
  },

  mounted() {
    this.description = descriptions.lecture;
  }
};
</script>

<style>
#lectures-info {
  margin-top: 3rem;
}
@media (max-width: 1023px) {
  #lectures-info {
    margin-left: 1.5rem;
    margin-right: 1.5rem;
  }
}
#lectures-box {
  background-color: rgb(242, 242, 242);
}
.action-details {
  padding: 2rem;
}
</style>
